import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import OtpForm from '../Partials/OtpForm/OtpForm';
import Footer from '../Partials/Footer/Footer';
import { setIsSubmit, setFormDetails, createOtp, reportDWH} from '../electricCompanyLeadBlockSlice';

const OtpFormPage = (props) => {

  //page params
  let btnText = 'לבדיקה';
  let currentPageFunction = handlePageContinue;
  let formid = 'electricCompanyLead';
  //page params

  useEffect(() => {
    gtag4({
      event: 'CounterCheck_Step1_InfoUpdatePage',
      step: '1',
      action: 'InfoUpdatePage',
    });
  }, []);

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='title'>מתקדמים לחשמל של {window.Config.brand_Name_HE}</h1>
      <h2 className='sub-title'>יש להכניס את תעודת הזהות שלך בכדי שנוכל לבדוק מול חברת חשמל</h2>
    </div>
  );

  let currentPageView = (
      <OtpForm isSubmit={props.isSubmit} onValid={handlePageValidate} />
  );

  return (
    <div className='electric-company-lead-wrapper'>
      {currentPageHeadline}
      <div className='electric-company-lead-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <Footer btnText={btnText} onclick={currentPageFunction} formid={formid} companyPrivacyPolicyLink={props.companyPrivacyPolicyLink} />
      </div>
    </div>
  );


  function handlePageValidate(data){
    props.setIsSubmit(false);
    gtag4({
      event: 'CounterCheck_Step1_InfoUpdateClick',
      step: '1',
      button: btnText,
      action: 'InfoUpdateClick',
    });
    if(data.isValid){
      props.setFormDetails(data.form);
      props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'Check Counter - Click' });
      props.createOtp();
    }
  }


  function handlePageContinue() {
    props.setIsSubmit(true);
  }


  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    isSubmit: state.electricCompanyLeadBlock.isSubmit,
    companyPrivacyPolicyLink: state.electricCompanyLeadBlock.cmsBlockData.companyPrivacyPolicyLink
  };
};

const mapDispatchToProps = {
  setIsSubmit,
  setFormDetails,
  createOtp,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpFormPage);
